import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M14.063 13.031a2.063 2.063 0 1 1-4.126 0 2.063 2.063 0 0 1 4.126 0z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.703 7.875h-2.577c-.329 0-.702-.291-.797-.673-.196-.78-.979-1.39-1.783-1.39h-3.094c-.805 0-1.587.611-1.797 1.452-.08.319-.451.61-.78.61H5.296c-.853 0-1.547.694-1.547 1.547v7.219c0 .853.694 1.547 1.547 1.547h13.406c.853 0 1.547-.694 1.547-1.547V9.421c0-.853-.694-1.547-1.547-1.547zM12 16.125c-1.706 0-3.094-1.388-3.094-3.094S10.294 9.937 12 9.937s3.094 1.388 3.094 3.094-1.388 3.094-3.094 3.094z"
  })]
}), 'CameraFilled');